'use strict';
define([], function () {
    function controller($scope, $element, $timeout, ReviewsService, LanguageService) {
        var vm = $scope;
        var visibilityObserver = null;
        var language = getLanguage();
        var copyByLanguage = {
            en: {
                eyebrow: 'Customer stories',
                titleLead: '500,000+ marketers',
                titleAccent: 'growing with SEO Tester Online.',
                featuredTitle: 'The key to their success',
                users: 'Marketers worldwide',
                analyses: 'SEO analyses every year',
                cta: 'Start your free trial',
                logoLabel: 'Brands from customer reviews'
            },
            it: {
                eyebrow: 'Le storie dei clienti',
                titleLead: '500.000+ marketer',
                titleAccent: 'che crescono con noi.',
                featuredTitle: 'La chiave del loro successo',
                users: 'Marketer nel mondo',
                analyses: 'Analisi SEO ogni anno',
                cta: 'Inizia la prova gratuita',
                logoLabel: 'Brand delle recensioni'
            },
            es: {
                eyebrow: 'Historias de clientes',
                titleLead: 'Más de 500.000 marketers',
                titleAccent: 'que crecen con nosotros.',
                featuredTitle: 'La clave de su éxito',
                users: 'Marketers en todo el mundo',
                analyses: 'Análisis SEO cada año',
                cta: 'Inicia la prueba gratuita',
                logoLabel: 'Marcas de las reseñas'
            },
            pl: {
                eyebrow: 'Historie klientów',
                titleLead: 'Ponad 500 000 marketerów',
                titleAccent: 'rośnie razem z nami.',
                featuredTitle: 'Klucz do ich sukcesu',
                users: 'Marketerów na świecie',
                analyses: 'Analiz SEO każdego roku',
                cta: 'Rozpocznij bezpłatny okres',
                logoLabel: 'Marki z opinii klientów'
            },
            fr: {
                eyebrow: 'Histoires clients',
                titleLead: 'Plus de 500 000 marketers',
                titleAccent: 'qui grandissent avec nous.',
                featuredTitle: 'La clé de leur réussite',
                users: 'Marketers dans le monde',
                analyses: 'Analyses SEO chaque année',
                cta: 'Commencer l’essai gratuit',
                logoLabel: 'Marques des témoignages'
            }
        };
        var portraits = {
            'Marialuisa Sanfilippo': '../assets/img/testimonials/hd/marialuisa-sanfilippo.png',
            'Matteo Pogliani': '../assets/img/testimonials/hd/matteo-pogliani.jpg',
            'Federico Papa': '../assets/img/testimonials/hd/federico-papa.jpg',
            'Alessandro La Rosa': '../assets/img/testimonials/hd/alessandro-la-rosa.jpg',
            'Bernardo Mannelli': '../assets/img/testimonials/hd/bernardo-mannelli.jpg',
            'Luca Rodino': '../assets/img/testimonials/hd/luca-rodino.jpg',
            'Carlo Camusso': '../assets/img/testimonials/hd/carlo-camusso.jpg',
            'Aaron Moss': '../assets/img/testimonials/hd/aaron-moss.jpg',
            'Luca Reina': '../assets/img/testimonials/hd/luca-reina.jpg',
            'Manuel Strano': '../assets/img/testimonials/hd/manuel-strano.jpg',
            'Francesco Ambrosino': '../assets/img/testimonials/hd/francesco-ambrosino.jpg',
            'Vittoria Averni': '../assets/img/testimonials/hd/vittoria-averni.jpg',
            'Antonio Santoro': '../assets/img/testimonials/hd/antonio-santoro.jpg',
            'Bill Dockett': '../assets/img/testimonials/hd/bill-dockett.jpg',
            'Marco Cardile': '../assets/img/testimonials/hd/marco-cardile.jpg'
        };
        var reviewLogos = [
            { name: 'TIM', image: '../assets/img/reviews-logos/tim-official.svg', wide: true, showLabel: false },
            { name: 'Oneminutesite.it', image: '../assets/img/reviews-logos/oneminutesite.png' },
            { name: 'Open-Box', image: '../assets/img/reviews-logos/open-box.png' },
            { name: 'Ludwig', image: '../assets/img/reviews-logos/ludwig.png' },
            { name: 'CreationDose', image: '../assets/img/reviews-logos/creationdose.png' },
            { name: 'toolperstartup.com', image: '../assets/img/reviews-logos/toolperstartup.png' },
            { name: 'SiteGround', image: '../assets/img/reviews-logos/siteground-official.svg', wide: true, showLabel: false },
            { name: 'Fattura24', image: '../assets/img/reviews-logos/fattura24.png' },
            { name: 'SalesRep.ai', image: '../assets/img/reviews-logos/salesrep.png' },
            { name: 'RiguardiBoutique', image: '../assets/img/reviews-logos/riguardi.png' },
            { name: 'HFarm School', image: '../assets/img/reviews-logos/hfarm-school.png' },
            { name: 'Trasporti Gianni Iuvarà', image: '../assets/img/reviews-logos/trasporti-gianni-iuvara.png', wide: true, showLabel: false },
            { name: 'Balance ADR Group', image: '../assets/img/reviews-logos/balance-adr.png' },
            { name: 'ShippyPro', image: '../assets/img/reviews-logos/shippypro.svg', wide: true, showLabel: false },
            { name: 'Coderblock.ai', image: '../assets/img/reviews-logos/coderblock.svg', wide: true, showLabel: false }
        ];

        vm.copy = copyByLanguage[language] || copyByLanguage.en;
        vm.visible = false;
        vm.testimonials = ReviewsService.getShowcaseAll().map(function (review, index) {
            return createShowcaseReview(review, index);
        });
        vm.featured = vm.testimonials[3];
        vm.featuredIndexLabel = '01 / ' + padNumber(vm.testimonials.length);
        vm.testimonialCards = vm.testimonials.filter(function (_, index) {
            return index !== 3;
        });
        vm.voiceColumns = [0, 7, 9].map(function (offset) {
            var column = [];
            for (var index = 0; index < 16; index++) {
                column.push(vm.testimonialCards[(index + offset) % vm.testimonialCards.length]);
            }
            return column;
        });
        vm.reviewRows = createReviewRows();
        vm.goToPlans = goToPlans;

        $timeout(observeVisibility, 0, false);

        $scope.$on('$destroy', function () {
            if (visibilityObserver) {
                visibilityObserver.disconnect();
                visibilityObserver = null;
            }
        });

        function createShowcaseReview(review, index) {
            return {
                category: review.category,
                message: review.message,
                name: review.name,
                role: formatRole(review),
                portrait: portraits[review.name] || '../assets/img/reviews/' + review.imgFile,
                originalIndex: index
            };
        }

        function formatRole(review) {
            if (!review.agency) {
                return review.jobTitle;
            }
            var prepositions = {
                it: ' a ',
                en: ' at ',
                es: ' en ',
                pl: ' w ',
                fr: ' à ',
                de: ' bei ',
                pt: ' em '
            };
            return review.jobTitle + (prepositions[language] || ' at ') + review.agency;
        }

        function createReviewRows() {
            var secondRowOffset = Math.ceil(reviewLogos.length / 2);
            return [
                {
                    logos: reviewLogos,
                    reverse: false
                },
                {
                    logos: reviewLogos.slice(secondRowOffset).concat(reviewLogos.slice(0, secondRowOffset)),
                    reverse: true
                }
            ];
        }

        function goToPlans(event) {
            event.preventDefault();
            var target = document.getElementById('select-choose-plan');
            if (target && target.scrollIntoView) {
                target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        function observeVisibility() {
            var section = $element[0].querySelector('.voice-section');
            if (!section || typeof window.IntersectionObserver !== 'function') {
                vm.visible = true;
                return;
            }
            visibilityObserver = new window.IntersectionObserver(function (entries) {
                if (!entries[0] || !entries[0].isIntersecting) {
                    return;
                }
                $scope.$evalAsync(function () {
                    vm.visible = true;
                });
                visibilityObserver.disconnect();
                visibilityObserver = null;
            }, { threshold: 0.12 });
            visibilityObserver.observe(section);
        }

        function padNumber(value) {
            return value < 10 ? '0' + value : String(value);
        }

        function getLanguage() {
            var locale = LanguageService.getCodeAndCountrySaveOnStorage() ||
                (navigator.language || 'en-US');
            return String(locale).toLowerCase().split('-')[0];
        }
    }

    controller.$inject = ['$scope', '$element', '$timeout', 'ReviewsService', 'LanguageService'];
    return {
        templateUrl: 'app/modules/upgrade/components/what-people-says-carousel/what-people-says-carousel.html',
        controller: controller
    };
});
